import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowFolderResponse,
  WorkflowFolderCreateRequest,
  WorkflowFolderUpdateRequest
} from '../models/workflow.model';

@Injectable({ providedIn: 'root' })
export class WorkflowFolderApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-folders`;

  constructor(private http: HttpClient) {}

  getFolders(businessId: number, activeOnly?: boolean): Observable<WorkflowFolderResponse[]> {
    let params = new HttpParams().set('businessId', businessId.toString());
    if (activeOnly !== undefined) {
      params = params.set('activeOnly', activeOnly.toString());
    }
    return this.http.get<WorkflowFolderResponse[]>(this.apiUrl, { params });
  }

  getById(id: number): Observable<WorkflowFolderResponse> {
    return this.http.get<WorkflowFolderResponse>(`${this.apiUrl}/${id}`);
  }

  create(request: WorkflowFolderCreateRequest): Observable<WorkflowFolderResponse> {
    return this.http.post<WorkflowFolderResponse>(this.apiUrl, request);
  }

  update(id: number, request: WorkflowFolderUpdateRequest): Observable<WorkflowFolderResponse> {
    return this.http.put<WorkflowFolderResponse>(`${this.apiUrl}/${id}`, request);
  }

  /**
   * INC_CRM_020 (2) inc9 — activar/inactivar. Es una acción propia y distinta de eliminar:
   * antes el único botón decía "Eliminar" pero el backend solo inactivaba.
   */
  setActive(id: number, active: boolean): Observable<WorkflowFolderResponse> {
    const params = new HttpParams().set('active', active.toString());
    return this.http.patch<WorkflowFolderResponse>(`${this.apiUrl}/${id}/active`, {}, { params });
  }

  /**
   * Borrado REAL (INC_CRM_020 (2) inc9). El backend lo rechaza con 400 si la carpeta sigue
   * activa o si todavía contiene workflows/subcarpetas.
   */
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
